import { AddAutomatedConfigurationCommand, AutomatedConfiguration } from '@era/settings-sdk';
import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const RolloutResolverActions = createActionGroup({
  source: 'Rollout Resolver',
  events: {
    'Rollouts Requested': emptyProps(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const RolloutApiActions = createActionGroup({
  source: 'Rollouts API',
  events: {
    'Rollouts Loaded': props<{ automatedConfigurations: AutomatedConfiguration[] }>(),
    'Rollouts Loaded error': props<{ error: ErrorModel }>(),
    'Rollout Added': props<{ addAutomatedConfigurationCommand: AddAutomatedConfigurationCommand }>(),
    'Rollout Added error': props<{
      addAutomatedConfigurationCommand: AddAutomatedConfigurationCommand;
      error: ErrorModel;
    }>(),
    'Rollout Deleted': props<{ id: string }>(),
    'Rollout Deleted error': props<{ id: string; error: ErrorModel }>(),
    'Rollout Updated': props<{ newAutomatedConfiguration: AutomatedConfiguration }>(),
    'Rollout Updated error': props<{ id: string; error: ErrorModel }>(),
  },
});

// ============================================================================
// LIST ACTIONS (Group - using createActionGroup)
// ============================================================================

export const RolloutListActions = createActionGroup({
  source: 'Rollout list',
  events: {
    'Rollout Added': props<{ automatedConfiguration: AutomatedConfiguration }>(),
    'Rollout Deleted': props<{ automatedConfiguration: AutomatedConfiguration }>(),
    'Rollout Updated': props<{
      originalAutomatedConfiguration: AutomatedConfiguration;
      newAutomatedConfiguration: AutomatedConfiguration;
    }>(),
  },
});
